module.exports = __webpack_public_path__ + "img/cases-brand-zedriv-5.aca8d9a1.png";